<script>
import moment from 'moment'
import FilePreviewImage from '@components/file-preview-image.vue'
import FilePreviewPdf from '@components/file-preview-pdf.vue'
export default {
  components: {
    FilePreviewImage,
    FilePreviewPdf,
  },
  data() {
    return {
      headers: [
        { text: 'Document Name', value: 'name' },
        { text: 'Access Expires', value: 'expiry_date' },
      ],
      documentList: [],
      senderName: '',
      acceptedTypes: ['jpg', 'jpeg', 'png'],
      pdfDialog: false,
      imageDialog: false,
      toPreview: null,
      extension: null,
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  mounted() {
    if (this.$route.params.responseData) {
      this.documentData = this.$route.params.responseData
      this.documentList = this.documentData.document_details
      this.senderName = this.$route.params.responseData.sender_name
      this.documentList.map((document) => {
        const datArr = document.expiry_date.split('T')
        document.expiry_date = moment(datArr[0]).format('MM/DD/YYYY')
      })
    } else {
      this.$router.go(-1)
    }
  },
  methods: {
    preview(item) {
      if (item.is_access_revoked) {
        this.$router.push({ name: 'share-record-link-revoked' })
      } else {
        this.toPreview = item
        this.extension = item.name.split('.').pop()
        if (this.extension === 'pdf') {
          if (this.mobile) {
            window.open(this.toPreview.url, '_blank')
          } else {
            this.pdfDialog = true
          }
        } else {
          if (this.acceptedTypes.includes(this.extension)) {
            this.imageDialog = true
          }
        }
      }
    },
    closeImageDialog() {
      this.toPreview = null
      this.extension = null
      this.imageDialog = false
    },
    closePDFDialog() {
      this.toPreview = null
      this.extension = null
      this.pdfDialog = false
    },
    rowClick(item) {
      if (!item.is_deleted) {
        this.preview(item)
      }
    },
  },
}
</script>

<template>
  <div :class="$style.divClass">
    <v-dialog
      :value="imageDialog"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewImage
        v-if="imageDialog && toPreview && extension"
        :attachment-id="toPreview.id"
        :title="toPreview.name"
        :type="extension"
        :src="toPreview.url"
        :attachments="[]"
        resource="vault"
        @closeOverlay="closeImageDialog"
      />
    </v-dialog>
    <v-dialog
      :value="pdfDialog && toPreview && extension"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewPdf
        v-if="pdfDialog"
        :attachment-id="toPreview.id"
        :attachments="[]"
        :src="toPreview.url"
        resource="vault"
        @closeOverlay="closePDFDialog"
      />
    </v-dialog>
    <h5 :class="$style.lableClass"
      >{{ senderName }} has shared documents with you</h5
    >
    <v-data-table
      :headers="headers"
      :items="documentList"
      hide-default-footer
      :class="$style.tableClass"
      @click:row="rowClick"
    >
      <!-- eslint-disable  -->
      <template v-slot:item.name="{ item }">
        <div
          :class="[
            item.is_deleted || item.is_access_revoked
              ? $style.strikeThrough
              : '',
          ]"
        >
          {{ item.name }}
        </div>
      </template>
      <template v-slot:item.expiry_date="{ item }">
        <div
          :class="[
            item.is_deleted || item.is_access_revoked
              ? $style.strikeThrough
              : '',
          ]"
        >
          {{ item.expiry_date }}
        </div>
      </template>
      <!-- eslint-enable -->
    </v-data-table>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.tableClass {
  margin: auto;
  border: 1px solid #93c0e8;
}
.divClass {
  width: 100%;
  padding: 12vh 20vw;
}
.lableClass {
  padding: 15px 0;
}
.strikeThrough {
  text-decoration: line-through;
  text-decoration-color: #6e6d6d;
}
</style>
